import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput,  FileField, Show, DeleteButton, usePermissions,
} from "react-admin";
import CreateView from "../../../components/CreateView";

import { ROLES, SERVER } from '../../../constants';
import { RaFileInput } from '../../../components/RaFileUploader';




export const StorageList = (props) => {
  const { permissions } = usePermissions();
  return (
    <List {...props} sort={{ field: 'updatedAt', order: 'DESC' }}>
      <Datagrid rowClick={null} sort={{ field: 'order', order: 'ASC' }}>
        {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
        <TextField source="title" label="عنوان" />
        <DateField options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="createdAt" label="تاریخ ایجاد" />
        <FileField label="فایل" source="attachment" src="url" title="دریافت" target="_blank" />
        {/* <ShowButton>نمایش</ShowButton> */}
        {permissions?.includes(ROLES.SUPER_ADMIN) && <DeleteButton>حذف</DeleteButton>}
      </Datagrid>
    </List>
  )
};


export const StorageShow = (props) => (
  <Show {...props} actions={null}>
    <SimpleShowLayout>
      <TextField source="title" label="عنوان" />
      <FileField label="فایل" source="attachment" src="url" title="دریافت" target="_blank" />

      <TextField source="attachment" label="لینک" />

      <DateField locales={"fa-IR"} source="createdAt" label="تاریخ ایجاد" />
      {/* <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" /> */}

    </SimpleShowLayout>
  </Show>
);


export const StorageCreate = (props) => {
  return (
    <CreateView {...props}>
      <TextInput source="title" label="عنوان" />
      {/* <FileInput source="attachfile" label="سند مربوطه" >
        <ImageField source="src" title="title" />
      </FileInput> */}
      <FileField label="فایل " source="attachments" src="url" title="دریافت" target="_blank" />
      <RaFileInput
        fullwidth={false}
        source="file"
        label="سند مربوطه"
        accept=""
        options={{type:"storage"}}
        className={'classFile'}
        uploadEndpoint={ `${SERVER}/admin/file`}
      />

    </CreateView>
  )
};
// uploadEndpoint={'http://karafsgym.com:8090/admin/api/v1/file-upload'}
